import React, { useState } from 'react';
import CategoryNode from './CategoryNode';

const CategoryGrid = ({ categories }) => {
    const [hoveredId, setHoveredId] = useState(null);

    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-y-12 sm:gap-y-16 gap-x-3 sm:gap-x-6 max-w-7xl mx-auto pb-20 px-4 sm:px-6">
            {categories.map((cat) => (
                <CategoryNode
                    key={cat.id}
                    cat={cat}
                    isHovered={hoveredId === cat.id}
                    onMouseEnter={() => setHoveredId(cat.id)}
                    onMouseLeave={() => setHoveredId(null)}
                />
            ))}
        </div>
    );
};

export default CategoryGrid;
